const styles = {
  bracketintro: {
    marginTop: '10px',
    paddingTop: '10px',
    borderTop: '1px solid lightgray',

  },
  bracketIntroInfo: {
    color: '#666',
    fontSize: '14px',
  },
  title: {
    fontFamily: 'League Gothic',
    fontSize: '30px',
    marginRight: '10px',
    color: '#7F1431',
  },
  bracket: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  bracketcontent: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 2fr 1fr 1fr 1fr',
    gridColumnGap: '10px',
    justifyContent: 'stretch',
    fontFamily: 'Roboto',
    minHeight: '350px',
    fontSize: '14px',
    marginBottom: window.innerWidth >= 600 ? 40 : 0,
  },

  spacer3: {
    flexGrow: '2.23',
  },
  leftside: {
    display: 'flex',
    flexGrow: '0.375',
  },
  eighths_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: '1',
  },
  eighths_left_top: {
    padding: '0 10px',
    flexGrow: '1',
  },
  eighths_left_bottom: {
    padding: '0 10px',
    flexGrow: '1',
  },
  quarters_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    margin: '26px 0',
    flexGrow: '1',

  },
  semis_left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: '1',
  },
  match_left: {
    borderRight: '1px solid lightgray',
    padding: '15px 10px',
  },
  finals: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 10px',
    flexGrow: '0.25',
  },
  final: {
    display: 'flex',
    fontSize: '16px',
    fontWeight: '700',
    flexGrow: '1',
    color: '#9C9BA4',
    width: '100%',
    marginBottom: '30px',
  },
  thirdfourth: {
    // marginTop: '60px',
    color: '#9C9BA4',
    flexGrow: '1',
  },
  match_right: {
    borderLeft: '1px solid lightgray',
    padding: '15px 10px',

  },
  semis_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'stretch',
    flexGrow: '1',
  },
  quarters_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'stretch',
    margin: '26px 0',
    flexGrow: '1',
  },
  eighths_right: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'stretch',
    flexGrow: '1',
  },
  eighths_right_top: {
    padding: '0 10px',
    flexGrow: '1',
  },
  eighths_right_bottom: {
    padding: '0 10px',
    flexGrow: '1',
  },
  rightside: {
    display: 'flex',
    flexGrow: '0.375',
  },
  roundsmobile: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: '300px',
    overflowX: 'auto',
  },
  roundname: {
    fontSize: '30px',
    fontFamily: 'League Gothic',
    textAlign: 'center',
    background: '#fff',
    borderBottom: '1px solid lightgray',
    padding: '10px 0',
  },
  finalname: {
    fontSize: '20px',
    textAlign: 'center',
    padding: '20px 0 0',
  },
};

export default styles;
